import React, { useEffect, useState } from 'react';
import api from '../../../api/axios';

const intentColorMap = {
  'Order Inquiry': 'bg-blue-100 text-blue-700 border-blue-200',
  'Product Query': 'bg-violet-100 text-violet-700 border-violet-200',
  'Delivery': 'bg-cyan-100 text-cyan-700 border-cyan-200',
  'Refund': 'bg-rose-100 text-rose-700 border-rose-200',
  'Payment': 'bg-amber-100 text-amber-700 border-amber-200',
  'Discount': 'bg-emerald-100 text-emerald-700 border-emerald-200',
  'Return': 'bg-orange-100 text-orange-700 border-orange-200',
  'General': 'bg-gray-100 text-gray-700 border-gray-200',
};

const SAIntentSection = ({ from, to }) => {
  const [intents, setIntents] = useState([]);

  useEffect(() => {
    if (!from || !to) return;
    let cancelled = false;
    api
      .get('/api/v1/shopping-assistance/intents', { params: { from, to } })
      .then((res) => {
        if (!cancelled) setIntents(res.data?.data || []);
      })
      .catch(() => {
        if (!cancelled) setIntents([]);
      });
    return () => { cancelled = true; };
  }, [from, to]);

  if (!intents.length) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm px-5 py-4">
      <p className="text-sm font-semibold text-gray-700 mb-3">Top Conversation Intent</p>
      <div className="flex flex-wrap gap-2">
        {intents.map((intent) => (
          <div
            key={intent.label}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-medium ${
              intentColorMap[intent.label] || 'bg-gray-100 text-gray-600 border-gray-200'
            }`}
          >
            <span>{intent.label}</span>
            <span className="font-bold">{intent.percentage}%</span>
            <div className="w-16 h-1.5 bg-white/60 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full bg-current opacity-50"
                style={{ width: `${intent.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SAIntentSection;
